import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-recent-evaluations',
  templateUrl: './recent-evaluations.component.html',
  styleUrls: ['./recent-evaluations.component.scss']
})
export class RecentEvaluationsComponent {
  @Input() data: any;
  public show: boolean = false;
  
  constructor() {}

  toggle(){
    this.show = !this.show;
  }
}
